<template>
    <div class="accordion-faq wow move-up" :key="toggleText">
        <div v-for="(data, tindex) in Faqs" :key="tindex" class="padding-top-60" :id="'faqCategory' + tindex" v-show="data.isshow==undefined || data.isshow==1">
            <h6 class="margin-vertical-30">{{data.category}}</h6>
            <b-card no-body v-for="(faq, index) in data.faqs" :key="index" v-show="faq.isshow==undefined || faq.isshow==1">
                <b-card-header header-tag="header">
                    <b-button block v-b-toggle="'faq' + tindex +'_'+ index" class="faq-title">{{faq.question}}</b-button>
                </b-card-header>
                <b-collapse :id="'faq' +  tindex +'_'+ index" v-model="faq.visible">
                    <b-card-body>
                        <b-card-text>
                            <span v-html="faq.answer"></span>
                        </b-card-text>
                    </b-card-body>
                </b-collapse>
            </b-card>
        </div>
        
        
    </div>
</template>
<style lang="scss" >
.accordion-faq a{color:#003f2d !important;}
</style>
<script>
    import Faqs from '../assets/consts/Faqs';

    export default {
        name: 'AccordionJan',
        props: ['toggleText'],
        data() {
            return {
                cur_lan:localStorage.getItem('cur_lan') || 'jp',
                Faqs: Faqs[localStorage.getItem('cur_lan') || 'jp'],
                searchToggleText: this.toggleText
            }
        },
        watch: {
            // toggleText(newVal) {
            toggleText() {    
                //this.searchToggleText = newVal
                this.searchFaq();
            }
        },
        monted() {
            this.searchFaq();
        },
        methods: {
            searchFaq() {
                for (const key in this.Faqs) {
                    if (this.Faqs.hasOwnProperty(key)) {
                        let a=0
                        this.Faqs[key].faqs.forEach(f => {
                            if(this.toggleText.trim() === '') {
                                 a++;
                                 f.isshow=1;
                            } else {
                                if(f.question.includes(this.toggleText.trim()) || f.answer.includes(this.toggleText.trim())){
                                    f.isshow=1;
                                    a++;
                                } else {
                                    f.isshow=0;
                                }
                                
                            }
                            return f;
                        });
                        this.Faqs[key].isshow=a>0?1:0;
                    }
                }
                
               
            }
        }
    };
</script>